const list = {
    index: 'Index/Index', 
    getUserCurVerifyCount: 'Index/getUserCurVerifyCount', //获取左侧菜单审批数量
    getUserInfo: 'User/get_user_info', //获取登录人 
};

export default list;